const defaultSearchConfiguration = {
    _searchable: true,
    email: { _searchable: true, _score: 500 },
    attemptType: { _searchable: true, _score: 300 },
    errorMessage: { _searchable: true, _score: 200 },
};

export default defaultSearchConfiguration;
